import { render, staticRenderFns } from "./reviewHistory.vue?vue&type=template&id=7661391e&scoped=true&"
import script from "./reviewHistory.vue?vue&type=script&lang=js&"
export * from "./reviewHistory.vue?vue&type=script&lang=js&"
import style0 from "./reviewHistory.vue?vue&type=style&index=0&id=7661391e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7661391e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7661391e')) {
      api.createRecord('7661391e', component.options)
    } else {
      api.reload('7661391e', component.options)
    }
    module.hot.accept("./reviewHistory.vue?vue&type=template&id=7661391e&scoped=true&", function () {
      api.rerender('7661391e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/reviewHistory.vue"
export default component.exports